import { memo } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { ITopTag } from 'src/interface';
import { Element, RouterLink as Link } from 'src/components';
import ContentTopTags from '../ContentTopTags';
import { isMiniappSelector } from 'src/selectors/app';

interface IProps {
    publisher: any;
    originalUrl?: string;
    redirectUrl: string;
    tags?: ITopTag[];
}

export default memo(function ContentSource({
    publisher = {},
    redirectUrl,
    originalUrl,
    tags = [],
}: IProps) {
    const isIframe = useSelector(isMiniappSelector);

    if (!publisher || !originalUrl) {
        return null;
    }

    return (
        <Element
            className={cn(
                'article-source',
                'text-[12px] leading-[1.5]',
                'font-semibold',
                'border-t border-solid border-[#F0F0F0]',
                'mt-[-12px] mb-[-8px] pt-[12px]',
            )}
        >
            <ContentTopTags tags={tags} />
            <Link
                className="font-semibold"
                to={redirectUrl || '/'}
                title="Xem bài gốc"
                newTab={isIframe}
                rel="nofollow"
            >
                <Element
                    className={'text-[#1A1A1A] font-[800]'}
                    renderAs="span"
                >
                    Nguồn {publisher.shortName}:{' '}
                </Element>
                <Element className={cn('text-[#808080]')} renderAs="span">
                    {originalUrl}
                </Element>
            </Link>
        </Element>
    );
});
